/**
 * Spaces available to cancel field
 *
 * Sorted in descending order, as it's most likely that a user wants to cancel all of their spaces.
 */
export function SpacesToCancelField({
  spacesAvailable,
}: {
  spacesAvailable: number;
}) {
  const options = [];
  for (let i = spacesAvailable; i > 0; i--) {
    options.push(
      <option key={i} value={i}>
        {i}
      </option>,
    );
  }
  return <>{options}</>;
}
